/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestServiceEndReportAiDto } from '../../models/request-service-end-report-ai-dto';
import { ServiceEndReportAiResponseDto } from '../../models/service-end-report-ai-response-dto';

export interface DocumentAiControllerServiceEndReportAi$Params {
  ticketId: string;
  centerId: string;
  type: string;
      body: RequestServiceEndReportAiDto
}

export function documentAiControllerServiceEndReportAi(http: HttpClient, rootUrl: string, params: DocumentAiControllerServiceEndReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceEndReportAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerServiceEndReportAi.PATH, 'post');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceEndReportAiResponseDto>;
    })
  );
}

documentAiControllerServiceEndReportAi.PATH = '/api/document-ai/service-end-report-ai/{ticketId}';
